import { createFileRoute } from '@tanstack/react-router';
import { ContestEditLobbyImagesStep } from '../pages/contests/edit/contest-edit-lobby-images-step';

export const Route = createFileRoute('/contests/$id/edit/lobby-images')({
  component: ContestEditLobbyImagesStep,
});
